var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5.16162C1 2.53641 1.02811 1.66162 4.5 1.66162C7.97189 1.66162 8 2.53641 8 5.16162C8 7.78683 8.01107 8.66162 4.5 8.66162C0.988927 8.66162 1 7.78683 1 5.16162Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.16162C12 2.53641 12.0281 1.66162 15.5 1.66162C18.9719 1.66162 19 2.53641 19 5.16162C19 7.78683 19.0111 8.66162 15.5 8.66162C11.9889 8.66162 12 7.78683 12 5.16162Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 16.1616C1 13.5364 1.02811 12.6616 4.5 12.6616C7.97189 12.6616 8 13.5364 8 16.1616C8 18.7868 8.01107 19.6616 4.5 19.6616C0.988927 19.6616 1 18.7868 1 16.1616Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.1616C12 13.5364 12.0281 12.6616 15.5 12.6616C18.9719 12.6616 19 13.5364 19 16.1616C19 18.7868 19.0111 19.6616 15.5 19.6616C11.9889 19.6616 12 18.7868 12 16.1616Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMod);
export default __webpack_public_path__ + "static/media/mod.baac2df65bd9ea5e4e95f072dda8b5f4.svg";
export { ForwardRef as ReactComponent };